<div class="row margin-top mt24">
  <div class="col-md col1-image">
      <img src="./assets/img/images/paperless.png" alt="Paperless trees" />
  </div>
  <div class="col-md">
    <p class="no-margin">{{ 'EPAY_ONE' | translate }}</p>
    <p class="no-margin">{{ 'EPAY_TWO' | translate }}</p>
    <p class="no-margin"><strong>{{ 'EPAY_THREE' | translate }}</strong></p>

    <h2 class="title no-border margin-top mt32">
      {{ 'POLICIES_ELEGIBLE' | translate }}
    </h2>
    <table class="table paperless-table">
      <tbody class="fake-black-color">
        <tr class="row-content border-full grey-border property enroll padding-vertical pv8" *ngFor="let pdetail of policyInfo">
          <td class="no-padding-left padding-right pr8 padding-vertical pv8 type-image">
            <img src="./assets/img/images/house_bg.png" width="20" *ngIf="pdetail.policyType === 'HOME'" alt="home background" />
            <img src="./assets/img/images/car_background.png" width="20" *ngIf="pdetail.policyType === 'AUTO'" alt="car background" />
          </td>
          <td class="no-padding-left policy-type-id padding-vertical pv8 align-middle padding-right pr8  width w-20">{{ pdetail.policyType }} &ndash; {{ pdetail.policynumber.policyNumber }} </td>
          <td class="no-padding green-text padding-vertical pv8 align-middle">{{ pdetail.effDate | date: 'shortDate' }} {{ 'TO' | translate }} {{ pdetail.expDate | date: 'shortDate' }}</td>
          
          <td class="padding-vertical pv8 enroll-button align-middle" *ngIf="pdetail.policyFlags.isEft === 'ENROLLED'">
            <mapfre-modal 
              [modalOptions]="endEnrollOptionsModal"
              [hideModal]="hideModal"
              (hideModalOutput)="resetHideModal()">
              <div class="modal-body">
                <hr class="margin-bottom mb24 no-margin-top" />
                <div class="margin-bottom mb24">
                    {{ 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_POLICY' | translate }} <strong>{{ pdetail.policynumber.policyNumber }}</strong> {{ 'REMOVE_FROM_E-PAY' | translate }}
                </div>
                <div class="mx-auto text-center">
                    <mapfre-button 
                      additionalClasses="basic default padding-vertical pv16 margin-bottom mb24 w-50 waves-effect"
                      (click)="cancellEnroll(pdetail.policynumber.policyNumber, user?.userDetails?.email?.address); hideModalAction($event)">
                      {{ 'REMOVE_FROM_E-PAY' | translate }}
                    </mapfre-button>
                    <mapfre-button 
                      additionalClasses="ghost secondary padding-vertical pv16  w-50 waves-effect"
                      (click)="hideModalAction($event)">
                      {{ 'CANCEL' | translate }}
                    </mapfre-button>
                </div>
              </div>
            </mapfre-modal>
            <a class="blue-text float-right align-middle edit-icon" [routerLink]="[pdetail.policynumber.policyNumber + '/enroll']"><svg-edit-icon-svg></svg-edit-icon-svg></a>
            <div class="float-right align-middle enrolled-icon"><svg-check-icon-svg></svg-check-icon-svg> <span class="green-text">{{ 'ENROLLED_TEXT' | translate }}</span></div>
          </td> 
          <td class="padding-vertical pv8 enroll-button align-middle pending" *ngIf="pdetail.policyFlags.isEft === 'ENROLLMENT-PENDING' ">
              <i class="fas fa-info-circle margin-right mr8"></i> <span>{{ 'PENDING_ENROLLMENT' | translate }}</span>
          </td>
          <td class="padding-vertical pv8 enroll-button align-middle pending" *ngIf="pdetail.policyFlags.isEft === 'UNENROLLMENT-PENDING' ">
              <i class="fas fa-info-circle margin-right mr8"></i> <span>{{ 'PENDING_REMOVAL' | translate }}</span>
          </td>
          <td class="padding-vertical pv8 enroll-button align-middle" *ngIf="pdetail.policyFlags.isEft === 'UNENROLLED'">
            <mapfre-button 
              additionalClasses="no-margin float-right w-100 primary ghost"
             [routerLink]="[pdetail.policynumber.policyNumber + '/enroll']">
              {{ 'ENROLL' | translate }}
            </mapfre-button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row margin-top mt32">
      <div class="col">
        <mapfre-button
          additionalClasses="link-button small red-link button-border-red"
          [backIcon]="'./assets/img/icons/back-arrow-red.png'"
          [iconClasses]="'align-middle'"
          [routerLink]="['/billing/paperless/e-policy']"
          [showIconsCustom]="true">  
          {{ 'BACK' | translate }}
        </mapfre-button>
      </div>
      <div class="col" *ngIf="!allEPayMethod(user)">
        <mapfre-button 
          additionalClasses="primary basic large  float-right waves-effect"
          [routerLink]="['/billing/paperless/e-bill']">
          {{ 'CONTINUE' | translate }}
        </mapfre-button>
      </div>
      <div class="col" *ngIf="allEPayMethod(user)">
        <mapfre-button 
          additionalClasses="primary basic large  float-right waves-effect"
          [routerLink]="['/billing/paperless']">
          {{ 'FINISH' | translate }}
        </mapfre-button>
      </div>
    </div>
  </div>
</div>
